export interface UserInfo {
  id: string;
  email: string;
  name?: string;
  companyId?: string;
  company_id?: string;
  company?: string;
  role?: string;
}

export function getUserInfo(): UserInfo | null {
  try {
    const userInfoStr = localStorage.getItem('userInfo');
    if (!userInfoStr) {
      return null;
    }
    
    const userInfo = JSON.parse(userInfoStr);
    return userInfo as UserInfo;
  } catch (error) {
    console.error('Error parsing user info:', error);
    return null;
  }
}

export function getUserCompany(): string {
  const userInfo = getUserInfo();
  
  // Coba ambil companyId (dari backend) atau company_id/company dari user info
  if (userInfo?.companyId) {
    return userInfo.companyId;
  }
  
  if (userInfo?.company_id) {
    return userInfo.company_id;
  }
  
  if (userInfo?.company) {
    return userInfo.company;
  }
  
  // Fallback ke environment variable jika tidak ada di user info
  return import.meta.env.COMPANY_OWNER || 'not_found';
}

export function isUserInCompany(deviceCompanyOwner: string | string[]): boolean {
  const userCompany = getUserCompany();
  
  // Jika sudah array, langsung cek
  if (Array.isArray(deviceCompanyOwner)) {
    return deviceCompanyOwner.includes(userCompany);
  }
  
  // Jika string, coba parse sebagai JSON array
  try {
    const companies = JSON.parse(deviceCompanyOwner);
    
    if (Array.isArray(companies)) {
      return companies.includes(userCompany);
    }
  } catch (error) {
    // Jika bukan JSON, cek sebagai string biasa
    return deviceCompanyOwner === userCompany;
  }
  
  return false;
}
